import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export type CorrectnessBreakdownResponse = {
  total: DefaultStats
  audited: DefaultStats
  manuallyAudited: DefaultStats
  autoAudited: DefaultStats
  correctness: DefaultStats
  correctnessBreakdown: CorrectnessBreakdown[]
  exceedsMinResolutions: DefaultStats
}

type DefaultStats = {
  current: number
  previous: number
  trend: number | null
}

type CorrectnessBreakdown = {
  timeslice: string
  correct_count: number
  incorrect_count: number
  avg_accuracy: number
  correct_percentage: number
}

const PLATFORM_CORRECTNESS_BREAKDOWN_V3_KEY = 'platform-correctness-breakdown-v3'

export function useGetCorrectnessBreakdownV3(
  period: { start?: string; end?: string } | null,
  granularity?: 'daily' | 'monthly' | 'weekly',
  orgId?: string,
  scope?: 'live'
) {
  return useQuery<CorrectnessBreakdownResponse>({
    queryKey: [PLATFORM_CORRECTNESS_BREAKDOWN_V3_KEY, period?.start, period?.end, granularity, orgId, scope],
    enabled: Boolean(period?.start) && Boolean(period?.end) && Boolean(granularity),
    queryFn: async () => {
      const { data } = await apiClient.get(`/int/v3/platform/correctness-breakdown`, {
        params: {
          start_time: period?.start,
          end_time: period?.end,
          granularity,
          org_profile_id: orgId,
          scope,
        },
      })
      return data
    },
  })
}
